
import axios from 'axios';
import { store } from '../redux/store/index';
import constants from './constants';
import { logout, updateAccessToken } from '../redux/action/authAction';
import { logoutWebsite } from '../redux/action/myAccountAction';
import { clearvoucherdata } from '../redux/action/cartAction';
import config from './config';
const api_url = constants.api_url;
const pendingRequests = new Map(); // To keep track of the pending requests

const axiosApiInstance = axios.create();
// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
    async (config) => {
    
        
        const token = store.getState().authReducer.accessToken;

        config.headers = {
            'X-Access-Token': `${token}`,
            'Content-Type': 'application/json' 
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
    //const requestKey = `${response.config.method} ${response.config.url}`;
    //pendingRequests.delete(requestKey); // Remove the request from the map
    return response
}, async function (error) {
    //const requestKey = `${error.config.method} ${error.config.url}`;
    //pendingRequests.delete(requestKey); // Remove the request from the map
    //const token = store.getState().authReducer.accessToken
    const email = store.getState().authReducer.userProfile_email


    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
        //force user logout - invalid
        if(!error.response.data.user_valid){
            config.logGeneral && console.log('error_interceptor',error.response.data.user_valid);
            store.dispatch(logout());
            store.dispatch(logoutWebsite());
            store.dispatch(clearvoucherdata());
            return false;
        }

        originalRequest._retry = true;
        
        const { data } = await axios.post(`${api_url}/api/refershtoken`, {'email': email})
        config.logGeneral && console.log("data.token",data.newToken);
        const update_token=data.newToken
        store.dispatch(updateAccessToken(update_token))

        axios.defaults.headers.common['X-Access-Token'] = update_token;
        return axiosApiInstance(originalRequest);
    }

   
    return Promise.reject(error);
});


/*
const pendingRequests = new Map(); // To keep track of the pending requests

// Cancel request if a request to the same URL is in progress
axios.interceptors.request.use(
    async (config) => {
        const token = store.getState().authReducer.accessToken;

        // Skip cancellation logic for GraphQL requests
        if (config.url.includes('graphql')) {
            // Do not apply the cancellation logic for GraphQL requests
            config.headers = {
                'x-access-token': token,
                'Content-Type': config.url.includes("file") ? 'multipart/form-data' : 'application/json',
            };
            return config;
        }

        // Check if the request URL is already pending, apply cancellation only for non-GraphQL URLs
        const requestKey = `${config.method} ${config.url}`;

        if (pendingRequests.has(requestKey)) {
            const cancel = pendingRequests.get(requestKey);
            cancel('Request canceled due to duplicate URL');
        }

        // Create a cancel token for the current request
        const source = axios.CancelToken.source();
        config.cancelToken = source.token;

        // Add the current request to the map of pending requests
        pendingRequests.set(requestKey, source);

        // Add the token to headers
        config.headers = {
            'x-access-token': token,
            'Content-Type': config.url.includes("file") ? 'multipart/form-data' : 'application/json',
        };

        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
    const requestKey = `${response.config.method} ${response.config.url}`;
    pendingRequests.delete(requestKey); // Remove the request from the map
    return response
}, async function (error) {
    const requestKey = `${error.config.method} ${error.config.url}`;
    pendingRequests.delete(requestKey); // Remove the request from the map
    const token = store.getState().authReducer.accessToken
    const email = store.getState().authReducer.userProfile_email


    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
     
        config.logGeneral && console.log('error_interceptor',error,token);
        originalRequest._retry = true;
     
        const { data } = await axios.post(`${api_url}/api/refershtoken`, {'email': email})
        config.logGeneral && console.log("data.token",data.token);
        const update_token=data.token
        updateAccessToken(update_token)

        axios.defaults.headers.common['x-access-token'] = update_token;
        return axiosApiInstance(originalRequest);
    }

   
    return Promise.reject(error);
});*/

export default axiosApiInstance;
